module.exports = __webpack_public_path__ + "static/media/ic_code.ba8263ca.svg";